module.exports = __webpack_public_path__ + "static/media/hiw-kitchen-bg-2720x1836.1844fe27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/hiw-kitchen-bg-2720x1836.jpg
// module id = 178
// module chunks = 0